module.exports = __webpack_public_path__ + "static/media/loc3_img19.e88bb43b.jpg";